



















































































































































import Vue from 'vue';

import imageEditor from './imageEditor.vue';
import { getAsFile, ImageType, buildImageFromURL, resizeImage, imageToCanvas } from '../../libs/resizeImage';

import { MDCChipSet } from '@material/chips';
import { MDCLinearProgress } from '@material/linear-progress';
import { MDCTextField } from '@material/textfield';
import { MDCMenu, MDCMenuAdapter } from '@material/menu';
import { MDCRipple } from '@material/ripple';
import { MDCDialog } from '@material/dialog';

import uuid from 'uuid/v4';
import filesize from 'filesize';
import Axios from 'axios';

export class InternalFile {
  public id: string;
  public name: string = '';
  public lastMod: Date = new Date();
  public size: number = 0;
  public tags: string[] = [];
  public jsFile: File | null;
  public uploaded: boolean;
  public onUpload: boolean = false;
  public type: string = '';

  constructor(file: File | null, uploadStatus: boolean) {
    this.id = uuid();
    this.jsFile = file;
    this.uploaded = uploadStatus;
  }
}

interface Data {
  file: InternalFile;
  prettySize: string;
  cancelToken: any;
  progress: HTMLElement;
  tagsHelper: string[];

  fileAsBase64: string;
  backdroudString: string;

  imageEditor: boolean;
}

export default Vue.extend({
  data(): Data {
    return {
      file: new InternalFile(null, false),
      cancelToken: null,
      prettySize: '',
      progress: {} as HTMLElement,
      tagsHelper: [] as string[],
      imageEditor: false,

      backdroudString: '',
    } as Data;
  },
  props: [
    'givenFile',
    'asSelector',
  ],
  mounted() {
    const chipSetEl = this.$el.querySelector('.mdc-chip-set') as HTMLElement;
    const chipSet = new MDCChipSet(chipSetEl);

    const textFieldElem = this.$el.querySelector('.mdc-text-field') as HTMLElement;
    const textField = new MDCTextField(textFieldElem);

    this.file = this.givenFile as InternalFile;
    if (this.file.jsFile != null) {
      this.file.name = this.file.jsFile.name;
      if (/^image/.test(this.file.jsFile.type)) {
        this.file.type = 'image';
        const blob = this.file.jsFile.slice();


        const reader = new FileReader();
        const v = this;
        reader.addEventListener('loadend', async () => {
          // reader.result contains the contents of blob as a typed array
          const buff = reader.result as string;
          this.fileAsBase64 = buff;
          this.backdroudString = 'url(' + buff + ')';
          // const elem = this.$el.querySelector('.mdc-card__media') as HTMLElement;
          // elem.style.backgroundImage = 'url(' + buff + ')';
          // elem.style.backgroundColor= 'red';
          const imgElem = await buildImageFromURL(buff);
          const resize = async () => {
            await resizeImage(imgElem, 800);
            const canvas = imageToCanvas(imgElem);
            const buff2 = canvas.toDataURL(ImageType.JPEG, 0.75);

            // Set the new resized image
            this.fileAsBase64 = buff2;
            this.backdroudString = 'url(' + buff2 + ')';

            // Build the new blob to have the real new size
            canvas.toBlob((blob2) => {
              const b = blob2 as Blob;
              v.file.size = b.size;
              v.prettySize = v.getPrettySize();
            }, ImageType.JPEG, 0.75);
          };
          if (blob.size > 1024 * 400) { // More than 400KB
            await resize();
            return;
          } else if (imgElem.width > 800) {
            await resize();
            return;
          }

          this.file.size = blob.size;
          this.prettySize = this.getPrettySize();

        });
        reader.readAsDataURL(blob);
      } else {
        console.log('?');
      }
    } else {
      if (this.file.type === 'image') {
        this.backdroudString = 'url("' + this.getLink() + '")';
        // const elem = this.$el.querySelector('.mdc-card__media') as HTMLElement;
        // const url = 'url("' + this.getLink() + '")';
        // elem.style.backgroundImage = url;
      }
    }

    this.prettySize = this.getPrettySize();

    if (this.asSelector) {
      const fabRipple = new MDCRipple(this.$el.querySelector('.mdc-fab') as HTMLElement);
    }
  },
  // beforeDestroy() {
  // },
  updated() { return; },
  methods: {
    getFileForEditor(): string {
      if (this.file.uploaded) {
        return this.getLink();
      }
      return this.fileAsBase64;
    },
    getPrettySize(): string {
      if (!this.file) {
        return filesize(this.givenFile.jsFile.size);
      } else if (this.file) {
        return filesize(this.file.size);
      }

      return '?';
    },
    upload() {
      const data = new FormData();
      const v = this as any;

      let previousUpdateTime = new Date();

      data.append('type', v.file.type);
      data.append('file', v.file.jsFile);
      const config = {
        onUploadProgress: (progressEvent: any) => {
          const now = new Date();
          if (now.getTime() - previousUpdateTime.getTime() > 250) {
            previousUpdateTime = now;
            const percentCompleted = progressEvent.loaded / progressEvent.total;
            v.progress.foundation_.setProgress(percentCompleted);
          }
        },
        cancelToken: new Axios.CancelToken(function executor(c: any) {
          // An executor function receives a cancel function as a parameter
          v.cancelToken = c;
        }),
      };
      Axios.put('/API/admin/content/' + v.file.id, data, config)
        .then((res) => {
          v.file.uploaded = true;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          v.file.onUpload = false;
          v.progress.foundation_.close();
          v.progress.foundation_.setProgress(0);
        });

      v.file.onUpload = true;

      const progEl = v.$el.querySelector('.mdc-linear-progress') as HTMLElement;

      v.progress = new MDCLinearProgress(progEl);
      v.progress.foundation_.open();
    },
    del() {
      const v = this as any;

      Axios.delete('/API/admin/content/' + v.file.id).then((resp) => {
        const files = v.$parent.$data.files as InternalFile[];
        let i = 0;
        for (const file of files) {
          if (file.id === v.file.id) {
            v.$parent.rmContent(i, 1);
            break;
          }
          i++;
        }
      });
    },
    cancel() {
      this.cancelToken();
    },
    getName(): string {
      const v = this as any;
      if (!v.file) {
        return v.givenFile.jsFile.name as string;
      } else if (v.file != null) {
        return v.file.name;
      }

      return '';
    },
    getType(): string {
      const v = this as any;

      if (v.file != null) {
        return v.file.type;
      }
      return '';
    },
    // isUploaded(): boolean {
    //   const v = this as any;

    //   if (v.file != null) {
    //     return v.file.uploaded;
    //   }
    //   return false;
    // },
    // isOnUpload(): boolean {
    //   const v = this as any;

    //   if (v.file != null) {
    //     return v.file.onUpload;
    //   }
    //   return false;
    // },
    getLink(): string {
      const v = this as any;
      return '/API/content/' + v.file.id + '/' + v.file.name;
    },
    getTags(): string[] {
      if (this.file != null) {
        return this.file.tags;
      }

      return [];
    },
    addTag(ev: MouseEvent | KeyboardEvent) {
      const inputElem = this.$el.querySelector('.mdc-chip input') as HTMLInputElement;
      const newTag = inputElem.value;

      if (newTag === '') {
        this.tagsHelper = [];
        return;
      }

      this.askForSimilarTags(newTag);

      if (ev instanceof KeyboardEvent) {
        if (ev.keyCode !== 13 && ev.keyCode !== 32) {
          return;
        }
      }

      inputElem.value = '';

      const v = this as any;

      if (v.file.tags.indexOf(newTag) >= 0) {
        return;
      }

      v.file.tags.push(newTag);

      v.updateFile();
    },
    rmTag(tag: string) {
      const v = this as any;

      // elem.parentElement.attributes['']
      const i = v.file.tags.indexOf(tag);

      // Get the list of files as the right type
      const list = v.file.tags as string[];
      // Get the start of the list to the index to remove
      const list1 = list.slice(0, i);
      // Get the end of the list from the index plus 1 to the end
      const list2 = list.slice(i + 1);
      // Concatenate the tow arrays
      const newList = list1.concat(list2);

      v.file.tags = newList;
      v.updateFile();
    },
    updateFile() {
      const v = this as any;
      Axios.post('/API/admin/content/' + v.file.id, v.file)
        .catch((resp) => {
          console.error(resp);
        });
    },
    askForSimilarTags(tag: string) {
      const v = this as any;
      Axios.get('/API/admin/content/matchingTags/' + tag).then((resp) => {
        const tags = resp.data;
        if (tags === '') {
          v.tagsHelper = [];
          return;
        }

        v.tagsHelper = [] as string[];

        if (tags) {
          for (const proposedTag of tags) {
            let found = false;
            for (const savedTag of v.file.tags as string[]) {
              if (savedTag === proposedTag) {
                found = true;
                break;
              }
            }
            if (!found) {
              v.tagsHelper.push(proposedTag);
            }
          }
        }

      });
    },
    addSugestedTag(tag: string) {
      const v = this as any;

      v.file.tags.push(tag);

      // clean
      v.tagsHelper = [];
      const inputElem = v.$el.querySelector('.mdc-chip input') as HTMLInputElement;
      inputElem.value = '';

      v.updateFile();
    },
    addSugestedTagEnter(ev: KeyboardEvent, tag: string) {
      if (ev.keyCode === 13) {
        this.addSugestedTag(tag);
      }
    },
    selected() {
      const parentVue = this.$parent.$parent as any;
      const file = this.file as InternalFile;
      parentVue.imageSelected(file.id as string);
    },
    goToEditor() {
      this.imageEditor = true;
    },
    async imageUpdatedFromEditor(canvas: HTMLCanvasElement) {
      const jsFile = await getAsFile(canvas, this.file.name, ImageType.JPEG, 0.75);

      this.imageEditor = false;
      this.file.size = jsFile.size;

      this.prettySize = this.getPrettySize();

      this.fileAsBase64 = canvas.toDataURL();
      this.backdroudString = 'url(' + this.fileAsBase64 + ')';

      this.file.jsFile = jsFile;

      if (this.file.uploaded) {
        this.upload();
      }
    },
    cancelFromEditor() {
      this.imageEditor = false;
    },
  },
  components: {
    imageEditor,
  },
});
